/**
 * MOSA-908. Display name for a data source in the list, sidebar and panel.
 * A sample always reads as "Sample", so the UI does not echo a long API name.
 */

export type NamedDatasource = {
  name?: string | null;
  isDemo?: boolean;
};

/** The label shown for a data source. Samples use a fixed word. */
export function datasourceDisplayName(
  datasource: NamedDatasource | null | undefined,
): string {
  if (datasource?.isDemo) {
    return "Sample";
  }
  const name = (datasource?.name ?? "").trim();
  return name || "Data source";
}
